<!-- Daily Activity -->
<mat-card class="w-100">
    <mat-card-content>
        <h4 class="text-center mb-56">Solicitudes Recibidas</h4>

        <div class="filtros-bandeja">
    <mat-form-field appearance="outline" class="buscador-bandeja">
        <mat-label>Buscar solicitud</mat-label>
        <input
            matInput
            [(ngModel)]="textoBusqueda"
            (input)="aplicarFiltroEstado()"
            placeholder="Nombre/Apellidos/Carnet/Cargo/Contrato/Estado" />

        <button
            mat-icon-button
            matSuffix
            type="button"
            *ngIf="textoBusqueda"
            (click)="textoBusqueda = ''; aplicarFiltroEstado()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filtro-tipo">
        <mat-label>Tipo</mat-label>
        <mat-select [(ngModel)]="tipoFiltro" (selectionChange)="aplicarFiltroEstado()">
            <mat-option *ngFor="let tipo of tiposFiltro" [value]="tipo">
                {{ tipo === 'TODOS' ? 'Todos' : capitalizeFirst(tipo.toLowerCase()) }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="filtro-estado">
        <mat-form-field appearance="outline">
            <mat-label>Filtrar por estado</mat-label>
            <mat-select [(ngModel)]="estadoFiltro" (selectionChange)="aplicarFiltroEstado()">
                <mat-option *ngFor="let estado of estadosFiltro" [value]="estado">
                    {{ estado === 'TODOS' ? 'Todos' : capitalizeFirst(estado.toLowerCase()) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="text-nowrap w-100">
                <!-- Id Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> N° </th>
                    <td mat-cell class="fw-medium" *matCellDef="let element; let i = index">
                        <ng-container *ngIf="dataSource.paginator" class="text-columnas">
                            {{ dataSource.paginator.length - (i + dataSource.paginator.pageIndex *
                            dataSource.paginator.pageSize) }}
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef class="text-columnas"> Servidor
                        Público </th>
                    <td mat-cell *matCellDef="let element" class="text-columnas">
                        <p class="mb-0 fw-medium">{{capitalizeFirst(element?.id_registro?.id_funcionario?.nombre ||
                            '')}}
                            {{capitalizeFirst(element?.id_registro?.id_funcionario?.paterno || '')}}
                            {{capitalizeFirst(element?.id_registro?.id_funcionario?.materno || '')}}
                            {{capitalizeFirst(element?.id_registro?.id_funcionario?.casada || '')}}</p>
                        <p class="mb-0 fw-normal op-5">{{ element?.id_registro?.id_cargo?.nombre }}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="contrato">
                    <th mat-header-cell *matHeaderCellDef class="text-columnas">
                        Contrato</th>
                    <td mat-cell *matCellDef="let element" class="text-columnas"
                        [ngStyle]="{'color': getColors(element?.id_registro?.id_cargo?.contrato || '')}">
                        <p class="mb-0 fw-medium">{{capitalizeFirst(element?.id_registro?.id_cargo?.contrato || '')}}
                        </p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="solicitud">
                    <th mat-header-cell *matHeaderCellDef class="text-columnas"> Tipo de Solicitud </th>
                    <td mat-cell *matCellDef="let element" class="text-columnas">
                        <p class="mb-0 fw-medium op-5">{{ capitalizeFirst(element?.id_contenido?.titulo) || ""}}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef class="text-columnas"> Fecha Envío </th>
                    <td mat-cell *matCellDef="let element" class="text-columnas">
                        <p class="mb-0 fw-medium">{{this.fechaConvert(element.fecha_envio | date: 'dd/MM/yyyy')}}</p>
                    </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef class="text-columnas"> Estado </th>
                    <td mat-cell *matCellDef="let element" class="text-columnas">
                        <span
                        class="estado estado-{{element.estado | lowercase}} rounded-pill estado-click"
                        (click)="abrirSolicitud(element)">
                        {{capitalizeFirst((element.estado).toLowerCase())}}
                      </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="displayedColumns.length">Sin solicitudes.</td>
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[8, 10, 15, 20, 50]" showFirstLastButtons>
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>